/**
 * Notification Badge Component
 * Shows unread notification count
 */
import React from 'react';
import { cn } from 'lib/utils';

const NotificationBadge = ({ count, className }) => {
  if (!count || count <= 0) return null;

  const displayCount = count > 99 ? '99+' : count;

  return (
    <span
      className={cn(
        'absolute -right-1 -top-1 flex h-5 min-w-5 items-center justify-center rounded-full bg-[var(--rely-color-brand-green)] px-1.5 text-[10px] font-bold text-[var(--rely-color-brand-black)] shadow-[var(--rely-shadow-selected)]',
        count > 99 && 'min-w-6',
        className
      )}
    >
      {displayCount}
    </span>
  );
};

export default NotificationBadge;
